module.exports = __webpack_public_path__ + "assets/img/paperwalletemptyC.262107b706e011d2be3f63c9bc81da53.svg";